import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EdsCategoryOpenAllOverviewsEvent extends EventV2<object> {}
